export type MJMLJsonObject =
  | MJMLJsonWithChildren
  | MJMLJsonWithContent
  | MJMLJsonSelfClosingTag;

type MJMLJsonWithChildren = {
  tagName: string;
  attributes?: Record<string, any>;
  children: MJMLJsonObject[];
};

type MJMLJsonWithContent = {
  tagName: string;
  attributes?: Record<string, any>;
  content: string;
};

type MJMLJsonSelfClosingTag = {
  tagName: string;
  attributes?: Record<string, any>;
};

// A modified version of https://github.com/mjmlio/mjml/blob/master/packages/mjml-core/src/helpers/jsonToXML.js
export const jsonToXML = (json: MJMLJsonObject): string => {
  const { tagName, attributes = {} } = json;

  const attrs = Object.keys(attributes)
    .map((attr) => `${attr}="${attributes[attr]}"`)
    .join(' ');

  if ('children' in json && json.children.length) {
    const children = json.children.map(jsonToXML).join('\n');
    return `<${tagName}${attrs === '' ? '>' : ` ${attrs}>`}${children}</${tagName}>`;
  }

  if ('content' in json) {
    return `<${tagName}${attrs === '' ? '>' : ` ${attrs}>`}${json.content ?? ''}</${tagName}>`;
  }

  return `<${tagName}${attrs === '' ? ' />' : ` ${attrs} />`}`;
};
